import React from "react";
import {Route, Routes} from "react-router-dom";

// Layout containers. The theme migration is complete: every authenticated page
// renders in the new PortalLayout shell, so the legacy Hyper app-shell layouts
// (Vertical/Detached/Horizontal/TwoColumn) and their redux-driven selection
// have been removed. DefaultLayout is a thin pass-through kept for the public
// auth/error pages.
import DefaultLayout from "../layouts/Default";
import PortalRouteLayout from "../layouts/PortalRouteLayout";

import {
    authProtectedFlattenRoutes,
    publicProtectedFlattenRoutes,
} from "./index";
import PrivateRoute from "./PrivateRoute";

interface IRoutesProps {
}

const AllRoutes = (props: IRoutesProps) => {
    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicProtectedFlattenRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <DefaultLayout {...props}>
                                    {route.element}
                                </DefaultLayout>
                            }
                            key={idx}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedFlattenRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <PrivateRoute {...route}>
                                    <PortalRouteLayout {...props} route={route}>
                                        {route.element}
                                    </PortalRouteLayout>
                                </PrivateRoute>
                            }
                            key={idx}
                        />
                    ))}
                </Route>
            </Routes>
        </React.Fragment>
    );
};

export default AllRoutes;
